import { useState } from "react";
import config from "../config";
import { platformLabel } from "../utils/brand";

interface Props {
  // URL opcional a la que linkea el banner. Si no se pasa, es solo imagen.
  href?: string;
  alt?: string;
}

// El arte vive en public/<Plataforma>/ (Maxdream / Laketravel), reemplazable en
// el server sin recompilar (como env.js) y propio de cada marca. Dos crops:
// desktop/retina (1710x140, ~12:1) y mobile (500x140, ~3.5:1), para no recortar
// el logo/texto en pantallas angostas.
// ?v= = cache-busting: al reemplazar el arte, subí BANNER_VERSION en env.js y el
// browser vuelve a bajar la imagen sin necesidad de hard-refresh.
const V = "?v=" + encodeURIComponent(config.BANNER_VERSION);
const DIR = process.env.PUBLIC_URL + "/" + platformLabel;
const SRC_DESKTOP = DIR + "/promo-banner.webp" + V;
const SRC_MOBILE = DIR + "/promo-banner-mobile.webp" + V;

export default function PromoBanner({ href, alt = "Promoción" }: Props) {
  // Si la plataforma no tiene arte (ej. Lake por ahora), ocultamos el banner en
  // vez de mostrar una imagen rota.
  const [failed, setFailed] = useState(false);
  if (failed) return null;

  const img = (
    <picture>
      <source media="(max-width: 576px)" srcSet={SRC_MOBILE} />
      <img
        className="promo-banner-img"
        src={SRC_DESKTOP}
        alt={alt}
        onError={() => setFailed(true)}
      />
    </picture>
  );

  if (href) {
    return (
      <a
        className="promo-banner"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {img}
      </a>
    );
  }

  return <div className="promo-banner">{img}</div>;
}
